import { types } from 'mobx-state-tree'

export const Discount = types.model("Discount", {
    description: "",
    amount: types.maybe(types.number),
})
